import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";

export const CTABand = () => {
  return (
    <section className="py-14 sm:py-18 lg:py-22 relative overflow-hidden">
      {/* Subtle gradient background */}
      <div
        className="absolute inset-0 opacity-40"
        style={{
          background:
            "linear-gradient(90deg, hsl(188 72% 38% / 0.10) 0%, hsl(35 80% 55% / 0.08) 100%)",
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-foreground mb-6">
            Ready to Put Your Kansas Rentals on Autopilot?
          </h2>
          <p className="text-lg md:text-xl text-foreground/80 mb-8 max-w-2xl mx-auto font-medium">
            Join property owners across Johnson County who trust us with their valuable investments
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" data-testid="cta-consultation-button" className="text-lg px-8 py-6 h-auto" asChild>
              <a href="#contact">Schedule Free Consultation</a>
            </Button>
            <Button
              size="lg"
              variant="outline"
              data-testid="cta-download-guide-button"
              className="text-lg px-8 py-6 h-auto"
              asChild
            >
              <a href="/get-free-analysis">Get Free Property Analysis</a>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTABand;
